import { msalInstance, loginRequest } from "./auth";

const API_BASE  = process.env.REACT_APP_API_BASE  || "/api";
const USE_MOCK  = process.env.REACT_APP_USE_MOCK   === "true" || process.env.NODE_ENV === "development";
const FUNC_KEY  = process.env.REACT_APP_FUNCTION_KEY || "";

// â”€â”€ Auth header â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
async function authHeader() {
  const account = msalInstance.getAllAccounts()[0];
  if (!account) return {};
  try {
    const r = await msalInstance.acquireTokenSilent({ ...loginRequest, account });
    return { Authorization: `Bearer ${r.accessToken}` };
  } catch { return {}; }
}

// â”€â”€ Base fetch â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
async function apiFetch(path, opts = {}) {
  const ah = await authHeader();
  const headers = {
    "Content-Type": "application/json",
    ...(FUNC_KEY ? { "x-functions-key": FUNC_KEY } : {}),
    ...ah,
    ...opts.headers,
  };
  const res = await fetch(`${API_BASE}${path}`, { ...opts, headers });
  if (!res.ok) {
    const err = await res.text().catch(() => `HTTP ${res.status}`);
    throw new Error(err);
  }
  return res.json();
}

// â”€â”€ Documents â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export async function getDocuments(filters = {}) {
  if (USE_MOCK) {
    const { mockDocuments } = await import("./mockData");
    let docs = [...mockDocuments];
    if (filters.status && filters.status !== "ALL") docs = docs.filter(d => d.status === filters.status);
    if (filters.search) {
      const q = filters.search.toLowerCase();
      docs = docs.filter(d => d.filename.toLowerCase().includes(q));
    }
    return docs;
  }
  const cleaned = Object.fromEntries(Object.entries(filters).filter(([,v]) => v && v !== "ALL" && v !== ""));
  const p = new URLSearchParams(cleaned).toString();
  return apiFetch(`/documents${p ? "?" + p : ""}`);
}

export async function getDocument(id) {
  if (USE_MOCK) {
    const { mockDocuments } = await import("./mockData");
    return mockDocuments.find(d => d.id === id);
  }
  // No single-doc endpoint â€” fetch list and find by id
  const docs = await apiFetch("/documents");
  return docs.find(d => d.id === id) || { id, filename: id, status: "QA_FAILED", qaScore: null, uploadedAt: null };
}

export async function getQAResult(documentId) {
  if (USE_MOCK) {
    const { mockQAResult } = await import("./mockData");
    await new Promise(r => setTimeout(r, 350));
    return mockQAResult;
  }
  return apiFetch(`/documents/${encodeURIComponent(documentId)}/qa-results`);
}

export async function getAuditLog(documentId) {
  if (USE_MOCK) {
    const { mockAuditLog } = await import("./mockData");
    return mockAuditLog;
  }
  return apiFetch(`/documents/${encodeURIComponent(documentId)}/audit`).catch(() => []);
}

export async function uploadDocument(file, onProgress, uploadedBy = "Unknown") {
  if (USE_MOCK) {
    for (let i = 0; i <= 100; i += 10) {
      await new Promise(r => setTimeout(r, 120));
      onProgress?.(i);
    }
    return { id: file.name, filename: file.name, status: "PROCESSING" };
  }

  const ah = await authHeader();
  const fd = new FormData();
  fd.append("file", file);

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.upload.onprogress = e => { if (e.lengthComputable) onProgress?.(Math.round(e.loaded / e.total * 100)); };
    xhr.onload  = () => {
      if (xhr.status === 409) { resolve(JSON.parse(xhr.responseText)); return; }
      xhr.status < 300 ? resolve(JSON.parse(xhr.responseText)) : reject(new Error(`HTTP ${xhr.status}`));
    };
    xhr.onerror = () => reject(new Error("Upload failed"));
    xhr.open("POST", `${API_BASE}/upload`);
    if (FUNC_KEY) xhr.setRequestHeader("x-functions-key", FUNC_KEY);
    Object.entries(ah).forEach(([k,v]) => xhr.setRequestHeader(k, v));
    if (uploadedBy) xhr.setRequestHeader("X-Uploaded-By", uploadedBy);
    xhr.send(fd);
  });
}

// â”€â”€ Batch Upload â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export async function batchUploadDocuments(files, batchName, uploadedBy = "Unknown", onFileProgress, force = false) {
  if (USE_MOCK) {
    const batchId = "mock-batch-" + Date.now();
    return { batch_id: batchId, total: files.length, uploaded: files.length, status: "PROCESSING" };
  }
  const ah = await authHeader();
  const fd = new FormData();
  files.forEach(f => fd.append("files", f));
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.upload.onprogress = e => { if (e.lengthComputable) onFileProgress?.(Math.round(e.loaded / e.total * 100)); };
    xhr.onload  = () => {
      if (xhr.status === 409) { resolve(JSON.parse(xhr.responseText)); return; }
      xhr.status < 300 ? resolve(JSON.parse(xhr.responseText)) : reject(new Error(`HTTP ${xhr.status}`));
    };
    xhr.onerror = () => reject(new Error("Batch upload failed"));
    xhr.open("POST", `${API_BASE}/batch/upload`);
    if (FUNC_KEY) xhr.setRequestHeader("x-functions-key", FUNC_KEY);
    Object.entries(ah).forEach(([k, v]) => xhr.setRequestHeader(k, v));
    xhr.setRequestHeader("X-Uploaded-By", uploadedBy);
    xhr.setRequestHeader("X-Batch-Name", batchName);
    xhr.setRequestHeader("X-Force-Upload", force ? "true" : "false");
    xhr.send(fd);
  });
}

export async function getBatchStatus(batchId) {
  if (USE_MOCK) {
    return { batch_id: batchId, status: "PROCESSING", total: 5, completed: 2, passed: 1, failed: 1, files: [] };
  }
  return apiFetch(`/batch/${encodeURIComponent(batchId)}/status`);
}
export async function getAuditData() {
  if (USE_MOCK) return { documents: [], aggregates: {}, generated_at: new Date().toISOString() };
  return apiFetch("/audit/data");
}
export async function getBatchHistory() {
  if (USE_MOCK) return [];
  return apiFetch("/batch/history").catch(() => []);
}
export async function getDashboardStats(range = "1w") {
  if (USE_MOCK) {
    const { mockDashboardStats, mockTrendData, mockCategoryScores } = await import("./mockData");
    return { stats: mockDashboardStats, trend: mockTrendData, categoryScores: mockCategoryScores };
  }
  const tzOffset = new Date().getTimezoneOffset();
  return apiFetch(`/dashboard/stats?range=${range}&tz_offset=${new Date().getTimezoneOffset()}`);
}

// â”€â”€ Agent â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export async function sendAgentMessage(message, documentId = null, history = []) {
  if (USE_MOCK) {
    await new Promise(r => setTimeout(r, 1100));
    const responses = [
      "Based on the indexed QA results, the most recent document failed 3 checks: the closing reader statement was absent, lateral documentation was missing from the digital handshake section, and the anesthesia documentation timestamp exceeded the 15-minute threshold from baseline. The event log itself was complete and chronologically sound.",
      "Reviewing all indexed documents, the most common failure point is the closing reader statement, appearing in 68% of failed documents. The second most common is lateral documentation â€” side of surgery not explicitly noted. I'd recommend adding a template reminder for both at the start of each case.",
      "I found the QA results for this document. Category breakdown: Digital Handshake: 4/5 pts (side of surgery missing), Opening/Closing: 2/8 pts (remote connection statement absent, closing statement absent), Baseline Anesthesia: 4/5 pts (anesthesia documented 23 minutes after baselines), Procedure Documentation: 2/2 pts (full pass), Surgeon Communication: 3/3 pts (full pass).",
      "Across all documents in the index, Digital Handshake checks have a 91% pass rate, while Opening/Closing checks have the lowest rate at 71%. The closing reader statement is the single most frequently failed individual check.",
    ];
    return {
      message: responses[Math.floor(Math.random() * responses.length)],
      sources: documentId
        ? [{ title: `QA: ${documentId}`, document: documentId, type:"qa_result", relevance: 0.92 }]
        : [{ title:"QA Results â€” All Documents", document:"index", type:"qa_result", relevance: 0.88 }]
    };
  }
  return apiFetch("/agent/chat", {
    method: "POST",
    body: JSON.stringify({ message, documentId, history }),
  });
}

// â”€â”€ PDF Viewer â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export async function getPdfUrl(documentId) {
  if (USE_MOCK) return { url: null };
  // Use proxy endpoint to avoid CORS issues with blob storage
  const key = FUNC_KEY ? `?code=${FUNC_KEY}` : "";
  return { url: `${API_BASE}/documents/${encodeURIComponent(documentId)}/pdf${key}` };
}

// â”€â”€ Reviewer decisions â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export async function getReviewerDecisions(documentId) {
  if (USE_MOCK) return [];
  return apiFetch(`/documents/${encodeURIComponent(documentId)}/review`).catch(() => []);
}

export async function submitReviewerDecision(documentId, ruleId, decision, comment, reviewedBy) {
  if (USE_MOCK) { await new Promise(r => setTimeout(r, 200)); return { success: true }; }
  return apiFetch(`/documents/${encodeURIComponent(documentId)}/review`, {
    method: "POST",
    body: JSON.stringify({ ruleId, decision, comment, reviewedBy }),
  });
}

export async function completeReview(documentId, reviewedBy, summary, auditType = "") {
  if (USE_MOCK) { await new Promise(r => setTimeout(r, 200)); return { success: true }; }
  return apiFetch(`/documents/${encodeURIComponent(documentId)}/complete-review`, {
    method: "POST",
    body: JSON.stringify({ reviewedBy, summary, auditType }),
  });
}

export async function getWaveformAnalysis(documentId) {
  if (USE_MOCK) {
    const { mockWaveformData } = await import("./mockData");
    return mockWaveformData;
  }
  return apiFetch(`/documents/${encodeURIComponent(documentId)}/waveforms`).catch(() => null);
}

export async function unlockReview(documentId, unlockedBy, auditType = "") {
  if (USE_MOCK) { await new Promise(r => setTimeout(r, 200)); return { success: true }; }
  return apiFetch(`/documents/${encodeURIComponent(documentId)}/unlock-review`, {
    method: "POST",
    body: JSON.stringify({ unlockedBy, auditType }),
  });
}

export async function closeDocument(documentId, closedBy, note = "") {
  if (USE_MOCK) { await new Promise(r => setTimeout(r, 200)); return { success: true }; }
  return apiFetch(`/documents/${encodeURIComponent(documentId)}/close`, {
    method: "POST",
    body: JSON.stringify({ closedBy, note }),
  });
}

export async function flagDocumentAlert(documentId, flaggedBy, action = "flag", note = "") {
  if (USE_MOCK) { await new Promise(r => setTimeout(r, 200)); return { success: true, alert_status: "MANUAL_ALERT", alert_count: 1 }; }
  return apiFetch(`/documents/${encodeURIComponent(documentId)}/alert-flag`, {
    method: "POST",
    body: JSON.stringify({ flaggedBy, action, note }),
  });
}

// â”€â”€ Per-File Audit Data â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export async function getFileAuditData(documentIds, auditType = "combined") {
  if (USE_MOCK) {
    return {
      audit_type: auditType,
      documents: documentIds.map(id => ({
        file_name: id, qa_score: 80, pass_count: 12, fail_count: 3, total_checks: 15,
        qa_checks: [], failed_checks: [], alerts: [], alert_status: "NO_ALERT",
        procedure_type: "ACDF", technologist_name: "Mock Tech", surgeon_name: "Mock Surgeon",
      })),
      generated_at: new Date().toISOString()
    };
  }
  return apiFetch("/audit/files", {
    method: "POST",
    body: JSON.stringify({ document_ids: documentIds, audit_type: auditType }),
  });
}

export async function runPidQa(patientId, uploadedBy = "Unknown", force = false) {
  if (USE_MOCK) { await new Promise(r => setTimeout(r, 2000)); return { success: true, patient_id: patientId }; }
  return apiFetch(`/pid/${encodeURIComponent(patientId)}/run-qa`, {
    method: "POST",
    body: JSON.stringify({ uploadedBy, force }),
  });
}

export async function getPidTrackers() {
  if (USE_MOCK) return [];
  return apiFetch("/pid/trackers").catch(() => []);
}

export async function recoverBatch(batchId) {
  return apiFetch(`/batch/${encodeURIComponent(batchId)}/recover`, {
    method: "POST",
  });
}

// â”€â”€ Admin QA Checks â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export async function getQAChecks() {
  return apiFetch("/settings/qa-checks");
}

export async function getModalities() {
  return apiFetch("/modalities");
}

export async function saveModalities(modalities) {
  return apiFetch("/modalities", {
    method: "PUT",
    body: JSON.stringify({ modalities }),
  });
}

export async function saveQAChecks(checks, modifiedBy) {
  return apiFetch("/settings/qa-checks", {
    method: "PUT",
    body: JSON.stringify({ checks, modifiedBy }),
  });
}

export async function getQAChecksVersions() {
  return apiFetch("/settings/qa-checks/versions");
}

export async function rollbackQAChecks(versionId) {
  return apiFetch("/settings/qa-checks/rollback", {
    method: "POST",
    body: JSON.stringify({ versionId }),
  });
}

export async function suggestCheckQuestion(question) {
  return apiFetch("/settings/qa-checks/suggest", {
    method: "POST",
    body: JSON.stringify({ question }),
  });
}


// ---------------------------------------------------------------------------
// Manager Sign Off (MSO)
// ---------------------------------------------------------------------------

export async function getMsoData(caseId) {
  const res = await fetch(`${API_BASE}/api/mso/${encodeURIComponent(caseId)}`, {
    headers: getAuthHeaders(),  // <-- match your existing pattern
  });
  if (!res.ok) throw new Error(`getMsoData failed: ${res.status}`);
  return res.json();
}

export async function submitMsoSignoff(caseId, payload) {
  // payload: { decision: 'approved'|'rejected', comments: string, items_acknowledged: string[] }
  const res = await fetch(`${API_BASE}/api/mso/${encodeURIComponent(caseId)}/signoff`, {
    method: 'POST',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`submitMsoSignoff failed: ${res.status}`);
  return res.json();
}

export async function regenerateMso(caseId) {
  const res = await fetch(`${API_BASE}/api/mso/${encodeURIComponent(caseId)}/regenerate`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error(`regenerateMso failed: ${res.status}`);
  return res.json();
}